const API = {
  top_album: "https://qtify-backend-labs.crio.do/albums/top",
  new_album: "https://qtify-backend-labs.crio.do/albums/new",
};

export default API;
